import React from "react";
import styled from "styled-components";

export default function Messages() {
  return <Container>Messages</Container>;
}
const Container = styled.div`
  height: 80%;
`;
